// 2020-06-27export { TropaReporteComponent } from './tropa-reporte.component';